import { render, staticRenderFns } from "./custom-rostering.vue?vue&type=template&id=15b28788&scoped=true&"
import script from "./custom-rostering.ts?vue&type=script&lang=ts&"
export * from "./custom-rostering.ts?vue&type=script&lang=ts&"
import style0 from "./custom-rostering.scss?vue&type=style&index=0&id=15b28788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b28788",
  null
  
)

export default component.exports